/**
 * Collapses every run of whitespace to one space and trims the ends.
 *
 * `innerText` keeps the source formatting of the markup, so the same link
 * label arrives as "\nPlay Bucs Predict\n\n" on one device and
 * "Play Bucs Predict" on another. A report that groups on the label would
 * split one link across several rows.
 */
export function normalizeText(text: string): string {
  return text.replace(/\s+/g, " ").trim();
}
